export default __webpack_public_path__ + "static/media/brand-CL.c96fec86.png";